// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import categoriesListSchema from '@alphaott/common-utils/utils/schemas/categories'

import type { Category } from '@alphaott/api-client/types/categories'

import { FETCH_CHANNEL_CATEGORIES } from '../../actions/channelCategories'

export type ChannelCategoriesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Category>,
  +result: Array<string>,
  +expires: ?number,
}

const initialState: ChannelCategoriesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  result: [],
  expires: null,
}

const channelCategories = typeToReducer(
  {
    [FETCH_CHANNEL_CATEGORIES]: {
      LOADING: (state): ChannelCategoriesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): ChannelCategoriesState => {
        const {
          meta: { ttl },
        } = action
        const { result } = normalize(action.payload.data, categoriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          result,
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): ChannelCategoriesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { channelCategories }
